import { UrlUtils } from "core/lib";
import InboxStore from "./inbox.store";
import InboxService, { CategoryDetails, Message } from "core/services/inbox.service";
import { inboxCache } from "@menu/core/inbox";
import { appSettings } from "core/config";

class InboxStoreManager {
    private _service = new InboxService();
    private _store: InboxStore;

    constructor(store: InboxStore) {
        this._store = store;
    }

    get store() {
        return this._store;
    }

    async populateAsync() {
        if (!appSettings.isEnabled.inbox) {
            return;
        }

        try {
            await this._populateAsync();
        } catch (error) {
            console.error("Error populating inbox store:", error);
            this._updateStore([], [], 0);
        }
    }

    public static GetMenuData(unreadCount = 0) {
        const culture = UrlUtils.getLanguageCode();
        return {
            display: true,
            unread: unreadCount,
            url: `/business/${culture}/mydstv/#/inbox`
        };
    }

    private async _populateAsync() {
        this.store.updateIsLoading(true);

        const messages: Message[] = [];
        const categoryNames: string[] = [];

        let unreadCount = 0;

        const response = await this._service.getInboxAsync();

        const categories = response.data;

        if (!categories.length) {
            const data = response.data as any;
            if (data.description === "No rows found") {
                this._updateStore(messages, categoryNames, unreadCount);
                return;
            }
        }

        categories.forEach((category) => {
            const categoryDetails: CategoryDetails = {
                id: category.id,
                title: category.title
            };

            category.messages.forEach((message) => {
                message.category = categoryDetails;
                unreadCount += message.isRead ? 0 : 1;
            });

            messages.push(...category.messages);
            categoryNames.push(category.title);
        });

        this._updateStore(messages, categoryNames, unreadCount);
    }

    private _updateStore(messages: Message[], categoryNames: string[], unreadCount: number) {
        this.store.updateMessages(messages);
        this.store.updateCategories(categoryNames);
        this.store.updateIsLoading(false);

        const data = InboxStoreManager.GetMenuData(unreadCount);
        inboxCache.set(unreadCount);

        const inboxEvent = new CustomEvent("inbox", { detail: data });
        console.log("Updating inbox", inboxEvent);

        document.dispatchEvent(inboxEvent);
    }

    reset() {
        console.log("Resetting");
        this.store.reset();
    }
}

export default InboxStoreManager;
